/**
 * Generate an object URL for a file and download it. Useful for browser-side downloads.
 *
 * @param {BlobPart} content - The content of the file to generate an object URL for.
 * @param {string} filename - The name of the file to download.
 * @param {string} mimeType - The MIME type of the file to download.
 */
export const downloadFile = (
  content: BlobPart,
  filename: string,
  mimeType: string,
) => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
